import { useCallback } from "react";

import {
  AnalyticsComponent,
  AnalyticsFieldName,
  ExploreResourcesAnalyticsEvent,
} from "@/constants/analytics/Analytics";
import { ExploreTestID } from "@/constants/TestID";
import { useAnalytics } from "@/services/Analytics";
import InformationalAccordion from "@/ui/composed/cards/InformationalAccordion";

enum WhyAttendGroupsConstants {
  description = "Equip patients and families tell us that connecting with others in similar situations helped them better support themselves—or their loved one—through the recovery process. Groups provide a place to share and to listen, as well as learn actionable tips and strategies from people who have been right where you are.\n\nAll groups are low-pressure, and you can participate as much or as little as you like. If you want to join with your camera off and just observe, you can do that, too. All Equip groups are free and included in your treatment.",
  title = "Why attend groups?",
}

const WhyAttendGroupsAccordion = () => {
  const { track } = useAnalytics();

  const handleTriggerPress = useCallback(
    (isOpen: boolean) => {
      track(ExploreResourcesAnalyticsEvent.InformationalBlurbRead, {
        Action: isOpen ? "Expand" : "Collapse",
        [AnalyticsFieldName.Component]: AnalyticsComponent.Accordion,
        [AnalyticsFieldName.Title]: WhyAttendGroupsConstants.title,
      });
    },
    [track],
  );

  return (
    <InformationalAccordion
      description={WhyAttendGroupsConstants.description}
      onTriggerPress={handleTriggerPress}
      testID={ExploreTestID.WhyAttendGroupsAccordion}
      title={WhyAttendGroupsConstants.title}
    />
  );
};

export { WhyAttendGroupsConstants };
export default WhyAttendGroupsAccordion;
